import script from "./NavMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./NavMenuItem.vue?vue&type=style&index=0&id=2d3c5a4c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3c5a4c"]])

export default __exports__